/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface DisablePracticeRequest {
    practiceId: string;
}

/**
 * 
 */
export class AdministrationApi extends runtime.BaseAPI {

    /**
     * Disable a practice (admin only)
     */
    async disablePracticeRaw(requestParameters: DisablePracticeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['practiceId'] == null) {
            throw new runtime.RequiredError(
                'practiceId',
                'Required parameter "practiceId" was null or undefined when calling disablePractice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/practices/{practiceId}/disable`.replace(`{${"practiceId"}}`, encodeURIComponent(String(requestParameters['practiceId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Disable a practice (admin only)
     */
    async disablePractice(requestParameters: DisablePracticeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.disablePracticeRaw(requestParameters, initOverrides);
    }

    /**
     * Get all users (admin only)
     */
    async getAllUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get all users (admin only)
     */
    async getAllUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAllUsersRaw(initOverrides);
    }

    /**
     * Get system analytics (admin only)
     */
    async getAnalyticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/analytics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get system analytics (admin only)
     */
    async getAnalytics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAnalyticsRaw(initOverrides);
    }

}
